var cache = {};
var prefix = 'x';
var isDev = process.env.NODE_ENV === 'development' || !process.env.NODE_ENV;
var rules = [];

var insert = function insert(rule) {
  return rules.push(rule);
};

var hyphen = function hyphen(str) {
  return str.replace(/[A-Z]|^ms/g, '-$&').toLowerCase();
};

var wrapMediaQuery = function wrapMediaQuery(rule, media) {
  return media === '' ? rule : media + "{" + rule + "}";
};

var createRule = function createRule(name, selector, prop, value) {
  var className = selector === '' ? "." + name : selector.includes('&') ? selector.replace('&', "." + name) : "." + name + selector;
  return className.trim() + "{" + hyphen(prop) + ":" + value + "}";
};

function parse(styles, selector, parentMedia) {
  if (selector === void 0) {
    selector = '';
  }

  if (parentMedia === void 0) {
    parentMedia = '';
  }

  var className = '';

  for (var key in styles) {
    var value = styles[key];

    if (value === undefined || value === null) {
      continue;
    }

    if (typeof value === 'object') {
      var media = /^@/.test(key) ? key : null;
      var chainedSelector = media ? selector : key.startsWith(':') ? "" + selector + key : selector + " " + key;
      className += parse(value, chainedSelector, media || parentMedia);
      continue;
    }

    var cacheKey = key + value + selector + parentMedia;

    if (cache[cacheKey]) {
      className += ' ' + cache[cacheKey];
    } else {
      var utilityClassName = prefix + rules.length.toString(36);
      var rule = wrapMediaQuery(createRule(utilityClassName, selector, key, value), parentMedia);
      insert(rule);
      cache[cacheKey] = utilityClassName;
      className += ' ' + utilityClassName;
    }
  }

  return className;
}

function cxs() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return styles.map(function (style) {
    return parse(style);
  }).join(' ').trim();
}

cxs.css = function () {
  return rules.sort().join('');
};

cxs.reset = function () {
  cache = {};

  while (rules.length) {
    rules.pop();
  }
};

if (typeof document !== 'undefined') {
  var sheet = document.head.appendChild(document.createElement('style')).sheet;

  insert = function insert(rule) {
    try {
      rules.push(rule);
      sheet.insertRule(rule, sheet.cssRules.length);
    } catch (error) {
      if (isDev) {
        console.warn('whoops, illegal rule inserted', rule);
      }
    }
  };
}

export default cxs;